import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { findRelativeActivatedRoute } from '../routing-helpers/routing-helpers';

/**
 * Route to a path relative to the current router URL, rather than the current component's active route.
 *
 * Should not be necessariy that much, but sometimes it is when navigation elements are in components
 * which are mounted up the navigation tree.
 *
 * Guidance from https://github.com/angular/angular/blob/14.3.0/packages/router/src/directives/router_link.ts
 */
@Directive({
    selector: ':not(a):not(area)[relativeRouterLink]'
})
export class RelativeRouterLinkDirective {
    @Input() relativeRouterLink?: string;

    @Input() relativeRouteNodeType = 'dashboard';

    constructor(private router: Router) {}

    /** @nodoc */
    @HostListener('click')
    onClick(): boolean {
        if (this.relativeRouterLink == null) {
            return true;
        }

        this.router.navigate([this.relativeRouterLink], {
            relativeTo: findRelativeActivatedRoute(
                this.router,
                this.relativeRouteNodeType
            ),
            queryParamsHandling: 'preserve'
        });
        return true;
    }
}
